import { MeetingResponse } from 'lib/api/meetings/types';
import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';
import {
  mapToGTMMeetingAttributes,
  transformMeetingResponseToGTMAttributes,
} from './utils';
import { GTMMeetingAttributes } from './types';

export function scheduleMeetingInteractionEvent({
  meetingResponse,
  livePageUrl,
  attendeeLimit,
}: {
  meetingResponse: MeetingResponse;
  livePageUrl: string;
  attendeeLimit: number;
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.SCHEDULE_MEETING,
  };

  const meetingAttributes = transformMeetingResponseToGTMAttributes(
    meetingResponse,
    livePageUrl,
    attendeeLimit
  );

  const gtmMeetingAttributes: GTMMeetingAttributes =
    mapToGTMMeetingAttributes(meetingAttributes);

  pushToDataLayer({
    ...eventAttributes,
    ...gtmMeetingAttributes,
  });
}
